import { AgentSaleType } from '../types';

export const tabs = { [AgentSaleType.NEW]: 'Новый пользователь', [AgentSaleType.CURRENT]: 'Действующий ' };
